import {
  EuerDeclarationBusinessAssetsSubformInputs,
  EuerDeclarationBusinessAssetsSubformCalculationResults,
} from "./types";

export const calculateBusinessAssetsSubformResults = (
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  inputs: EuerDeclarationBusinessAssetsSubformInputs
): EuerDeclarationBusinessAssetsSubformCalculationResults => {
  return { businessAssetsResult: 0 };
};
